// 日志统计, todo

// eslint-disable-next-line @typescript-eslint/no-empty-function
export default function log() {}
